import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { containerVariants, textVariants, imageVariants, container } from '../../script/animation';
import ForDetail from '../ForDetail';
import { Link } from 'react-router';

const Section0 = () => {
    const { t } = useTranslation();

    return (
        <div className='w-full grid grid-cols-11 relative bg-white'>
            <div className='col-start-2 col-span-9 lg:col-start-3 lg:col-span-7 z-50 py-20'>
                <motion.div
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="visible"
                    className='grid grid-cols-1 md:grid-cols-2 md:gap-10 lg:gap-x-20'
                >
                    <Link to={'/neden-genesis-trade-lojistik'} className='flex flex-col justify-center group'>
                        <motion.h1
                            className="text-56 text-[#000C26] mb-3"
                            variants={container}
                            initial="hidden"
                            whileInView="visible"
                        >
                            {t('neden_genesis_title-1')}
                        </motion.h1>
                        <motion.p variants={textVariants} className='text-customGray text-18'>
                            {t('neden_genesis_description')}
                        </motion.p>
                        <ForDetail />
                    </Link>
                    
                    <motion.div variants={imageVariants} className='relative'>
                        <img src='/images/home-mini-banner/0.png' className='object-contain' alt="Neden Genesis" />
                    </motion.div>
                </motion.div>
            </div>
        </div>
    );
};

export default Section0;
